import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "board-map" }

import { domainEndpoint } from '@/api/axios';
import domainRepository from '@/api/domainRepository';
import OlMap from '@/components/general/OlMap.vue';
import useConverter from '@/composables/general/useConverter';
import useMapWizard from '@/composables/map/useBmsMap';
import { IMapSettings } from '@/models/project.model';
import { domainStore } from '@/store/domain-store';
import { messageStore } from '@/store/message-store';
import { UrlParams } from '@vueuse/core';
import { PropType, computed, ref } from 'vue';

export default /*#__PURE__*/_defineComponent({
  props: {
  height: {
    type: Number,
    required: false,
    default: 500,
  },
  params: { type: Object as PropType<UrlParams>, required: true },
  zoomToDefault: { type: Boolean, required: false, default: false },
},
  emits: ['switch-detail-view', 'new-map-extent'],
  setup(__props, { emit }) {

const props = __props




const fetchAllAndRefetchMarkers = ref(true);
const mapData = ref<IMapSettings>();

const { mapConfig } = useMapWizard();
const theDomainEndpoint = domainEndpoint();

const { convertArrayToApiParams } = useConverter();
// Initialization

domainRepository.getBmsDomainConfig().then(response => {
  mapData.value = response.map_settings;
});

const domainid = computed(() => domainStore.getState().domainid);
const message = computed(() => messageStore.getState().message);
const currentMapPosition = computed(() => {
  if (message.value) {
    return { lat: message.value.lat, lon: message.value.lon, zoom: 18 };
  } else if (props.zoomToDefault) {
    return { lat: mapData.value?.position.lat, lon: mapData.value?.position.lon, zoom: mapData.value?.zoom.default };
  } else return { lat: 0, lon: 0, zoom: 0 };
});

// +----------------+
// |    Computed    |
// +----------------+
const filterParams = computed(() => {
  const modifiedParams = { ...props.params };
  modifiedParams.top_type = modifiedParams.type;
  delete modifiedParams.type;
  delete modifiedParams.messageid;
  delete modifiedParams.detail;
  delete modifiedParams.pageid;
  return modifiedParams;
});

// +----------------+
// |    Methods     |
// +----------------+
function openFeature(id: number) {
  emit('switch-detail-view', { messageid: id, detail: 1 }, true);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (mapData.value && _unref(theDomainEndpoint) && _unref(currentMapPosition))
      ? (_openBlock(), _createBlock(OlMap, {
          key: 0,
          height: __props.height,
          filterParams: _unref(convertArrayToApiParams)(_unref(filterParams)),
          config: _unref(mapConfig)(_unref(theDomainEndpoint), mapData.value, fetchAllAndRefetchMarkers.value),
          setMarkerAllowed: false,
          domainid: _unref(domainid),
          refetchMessages: fetchAllAndRefetchMarkers.value,
          initial_lat: _unref(currentMapPosition).lat,
          initial_lon: _unref(currentMapPosition).lon,
          initial_zoom: _unref(currentMapPosition).zoom,
          centerSingleMarker: true,
          customButtonRenderer: 'bmsBoard',
          showPopupAllowed: !__props.params.messageid,
          onOpenFeature: openFeature
        }, null, 8, ["height", "filterParams", "config", "domainid", "refetchMessages", "initial_lat", "initial_lon", "initial_zoom", "showPopupAllowed"]))
      : _createCommentVNode("", true)
  ]))
}
}

})